import apiClient from "../lib/api-client";

export type AdjustmentType =
  | "DAMAGE"
  | "EXPIRY"
  | "THEFT"
  | "CORRECTION"
  | "OPENING_STOCK"
  | "TRANSFER_IN"
  | "TRANSFER_OUT"
  | "RETURN_TO_SUPPLIER";

export interface StockAdjustment {
  id: string;
  productId: string;
  batchId?: string;
  storeId: string;
  type: AdjustmentType;
  quantity: number;
  direction?: "IN" | "OUT";
  reason?: string;
  notes?: string;
  reference?: string;
  createdAt: string;
  batch?: {
    id: string;
    batchNumber: string;
    expiryDate: string;
    product: {
      id: string;
      name: string;
    };
  };
}

export interface CreateStockAdjustmentDto {
  storeId: string;
  batchId: string;
  type: AdjustmentType;
  quantity: number;
  reason: string;
  notes?: string;
  reference?: string;
  direction?: "IN" | "OUT";
}

export interface StockAdjustmentListResponse {
  data: StockAdjustment[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const stockAdjustmentService = {
  async create(data: CreateStockAdjustmentDto, idempotencyKey?: string) {
    const response = await apiClient.post("/stock-adjustments", data, {
      headers: { "Idempotency-Key": idempotencyKey || crypto.randomUUID() },
    });
    return response.data;
  },

  async getAll(params?: {
    page?: number;
    limit?: number;
    storeId?: string;
    productId?: string;
    batchId?: string;
    type?: AdjustmentType;
    direction?: "IN" | "OUT";
    search?: string;
  }): Promise<StockAdjustmentListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append("page", params.page.toString());
    if (params?.limit) searchParams.append("limit", params.limit.toString());
    if (params?.storeId) searchParams.append("storeId", params.storeId);
    if (params?.productId) searchParams.append("productId", params.productId);
    if (params?.batchId) searchParams.append("batchId", params.batchId);
    if (params?.type) searchParams.append("type", params.type);
    if (params?.direction) searchParams.append("direction", params.direction);
    if (params?.search) searchParams.append("search", params.search);

    const response = await apiClient.get(`/stock-adjustments?${searchParams}`);
    return response.data;
  },
};
